import { Injectable } from "@angular/core";
import { ResourceService } from "./resource.service";
import { HttpClient } from "@angular/common/http";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { UserModel } from "../model/user.model";

@Injectable({
    providedIn: 'root'
  })
  export class NotificationService extends ResourceService<any> {
  
    constructor(
      http: HttpClient, 
      settings: GlobalSettings, 
      authService: AuthenticationService) {
        super(http, "motor/Notifications", settings.politicasUrl, authService)
    }
  }